import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import MonekPaymentForm from '../component/MonekPaymentForm';
import PriceSummery from '../component/PriceSummery';
import Footer from '../component/Footer';
import Header from '../component/Header';
import godaddyImage from './../assets/images/globle.png';
import './payment.css';


function PayDeposit() {
    const location = useLocation();
    const navigate = useNavigate();
    const { paymentModel, editableAddress: passedEditableAddress, title } = location.state || {}; // Get data from navigation state
    const referenceCode = localStorage.getItem('loginData');
    const refData = JSON.parse(referenceCode);

    const [cardInfoCorrect, setCardInfoCorrect] = useState('yes');
    const [showPaymentForm, setShowPaymentForm] = useState(false);

    // Initialize local editable address
    const getInitialEditableAddress = () => {
        if (passedEditableAddress) return passedEditableAddress;

        const phoneValue = paymentModel?.phone || '';
        const phoneNumber = phoneValue ? phoneValue.replace(/^\+?44/, '').replace(/^0/, '') : '1234567890';

        return {
            address1: paymentModel?.Address1 || '447 Knights Manor Way',
            address2: paymentModel?.Address2 || 'Dartford',
            address3: paymentModel?.Address3 || 'Kent',
            addressCounty: '',
            postcode: paymentModel?.Postcode || 'DA1 5SL',
            country: 'United Kingdom',
            phoneCountryCode: '44',
            phoneNumber: phoneNumber,
            email: paymentModel?.Email || 'gavin.chitticks@paragon-uk.net'
        };
    };

    const [editableAddress, setEditableAddress] = useState(getInitialEditableAddress());

    useEffect(() => {
        sessionStorage.setItem('editableAddress', JSON.stringify(editableAddress));
    }, [editableAddress]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Redirect if no payment model (optional, good for safety)
    useEffect(() => {
        if (!paymentModel) {
            // navigate('/bankdetails'); // Uncomment if you want strict redirection
        }
    }, [paymentModel, navigate]);


    if (!paymentModel) {
        return (
            <>
                <Header />
                <div className='product-page-main-area'>
                    <Container fluid>
                        <Container>
                            <div className="alert alert-warning mt-5">No payment details found. Please go back and retry.</div>
                        </Container>
                    </Container>
                </div>
                <Footer />
            </>
        )
    }

    const {
        TotalToPay,
        Address1,
        Address2,
        Address3,
        Postcode,
        Email,
        phone,
    } = paymentModel;

    // Format phone number with country code
    const formattedPhone = phone ? (phone.startsWith('+') ? phone : `+44${phone.replace(/^0/, '')}`) : '+441234567890';

    // Format full address
    const fullAddress = [
        Address1 || '447 Knights Manor Way',
        Address2 || 'Dartford',
        Address3 || 'Kent',
        Postcode || 'DA1 5SL',
        'United Kingdom'
    ].filter(Boolean).join('\n');

    const handleContinue = () => {
        setShowPaymentForm(true);
    };

    return (
        <div className="page-main-area">
            <Header />
            <div className='product-page-main-area'>
                <Container fluid>
                    <Container>
                        <Row className='mt-4'>
                            <Col md={8}>
                                <div className='payment-page-left-area product-details-left'>
                                    {/* Page Title */}
                                    <h2 className="mb-3 payment-title">Payment</h2>
                                    <div className="p-4 mb-3 payment-intro-box">
                                        <p className="mb-4 payment-intro-text mb-0">
                                            Finally, we require a credit or debit card payment of <strong>£{TotalToPay}</strong>. Please enter your credit or debit card details below. Once again, please be reassured this is a secure SSL encrypted service, so your details are safe.
                                        </p>
                                    </div>
                                    {/* Main Content Section with Background Color */}
                                    <div className="payment-section-container">
                                        {/* Instructions */}


                                        {/* Please confirm your payment card details Section */}
                                        <div className="mb-3">


                                            <div
                                                className="mb-4 clickable-header"
                                                onClick={() => setShowPaymentForm(false)}
                                            >
                                                <div className="p-3 mb-0 payment-blue-header">
                                                    <h4 className="mb-0 payment-header-text"> Please confirm your payment card details</h4>
                                                </div>

                                            </div>

                                            {/* Section Content */}
                                            {!showPaymentForm && (
                                                <div className="address-info p-0">
                                                    <div className="mb-2 d-flex align-items-start">
                                                        <label className="form-label mb-0 payment-field-label">
                                                            Address:
                                                        </label>
                                                        <p>{fullAddress}</p>

                                                    </div>

                                                    {/* Phone Number Field - Label left, input right */}
                                                    <div className="mb-2 d-flex align-items-center">
                                                        <label className="form-label mb-0 payment-field-label">
                                                            Phone number:
                                                        </label>
                                                        <p>{formattedPhone}</p>

                                                    </div>

                                                    {/* Email Address Field - Label left, input right */}
                                                    <div className="mb-2 d-flex align-items-center">
                                                        <label className="form-label mb-0 payment-field-label">
                                                            Email address:
                                                        </label>
                                                        <p>{Email || 'gavin.chitticks@paragon-uk.net'}</p>

                                                    </div>


                                                    {/* Confirmation Question with Yes/No Buttons */}
                                                    <div className="mb-0">
                                                        <label className="form-label mb-3 d-block payment-confirm-question">
                                                            Are the details for the account holder correct?
                                                        </label>
                                                        <div className="d-flex gap-3">
                                                            <button
                                                                type="button"
                                                                onClick={() => setCardInfoCorrect('yes')}
                                                                className={`payment-confirm-btn ${cardInfoCorrect === 'yes' ? 'active' : 'inactive'}`}
                                                            >
                                                                Yes
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => setCardInfoCorrect('no')}
                                                                className={`payment-confirm-btn ${cardInfoCorrect === 'no' ? 'active' : 'inactive no-inactive'}`}
                                                            >
                                                                No
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Editable Address Section - Shows when "No" is selected */}
                                        {!showPaymentForm && cardInfoCorrect === 'no' && (
                                            <div className="mb-4 editable-address-section">
                                                <div className="mb-3 d-flex align-items-start">
                                                    <label className="form-label mb-0 editable-label">Address:</label>
                                                    <div className="editable-field-wrapper">
                                                        {/* Address Line 1 */}
                                                        <div className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={editableAddress.address1}
                                                                onChange={(e) => setEditableAddress({ ...editableAddress, address1: e.target.value })}
                                                                placeholder="Address Line 1"
                                                            />
                                                        </div>

                                                        {/* Address Line 2 */}
                                                        <div className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={editableAddress.address2}
                                                                onChange={(e) => setEditableAddress({ ...editableAddress, address2: e.target.value })}
                                                                placeholder="Address Line 2"
                                                            />
                                                        </div>

                                                        {/* Address Line 3 */}
                                                        <div className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={editableAddress?.address3}
                                                                onChange={(e) => setEditableAddress({ ...editableAddress, address3: e.target.value })}
                                                                placeholder="Address Line 3"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Postcode */}
                                                <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Postcode:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={editableAddress.postcode}
                                                            onChange={(e) => setEditableAddress({ ...editableAddress, postcode: e.target.value })}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Country */}
                                                <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Country</label>
                                                    <div className="editable-input-container">
                                                        <select
                                                            className="form-select"
                                                            value={editableAddress.country}
                                                            onChange={(e) => setEditableAddress({ ...editableAddress, country: e.target.value })}
                                                        >
                                                            <option value="United Kingdom">United Kingdom</option>
                                                            <option value="England">England</option>
                                                            <option value="Scotland">Scotland</option>
                                                            <option value="Wales">Wales</option>
                                                            <option value="Northern Ireland">Northern Ireland</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Phone Number */}
                                                <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Phone number:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="tel"
                                                            className="form-control"
                                                            value={editableAddress.phoneNumber}
                                                            onChange={(e) => setEditableAddress({ ...editableAddress, phoneNumber: e.target.value })}
                                                            placeholder="1234567890"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Email Address */}
                                                <div className="mb-0 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Email address:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            value={editableAddress?.email}
                                                            onChange={(e) => setEditableAddress({ ...editableAddress, email: e.target.value })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Continue to Payment Button */}
                                        {!showPaymentForm && (
                                            <div className="justify-content-end mb-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg continue-payment-btn btn btn-primary"
                                                    onClick={handleContinue}
                                                >
                                                    Continue to Payment
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    {/* Payment Section */}
                                    <div className="mb-4 mt-4">
                                        <div
                                            className={`p-3 mb-0 payment-form-header ${cardInfoCorrect === 'yes' ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                            onClick={() => { if (cardInfoCorrect === 'yes') setShowPaymentForm(true); }}
                                        >
                                            <h4 className="mb-0 payment-header-text">Payment</h4>
                                        </div>
                                        {showPaymentForm && (
                                            <div className="p-1 payment-form-body">
                                                <div className="payment-form-inner">
                                                    <MonekPaymentForm
                                                        model={paymentModel}
                                                        editableAddress={editableAddress}
                                                        isTest={true}
                                                        embed={true}
                                                        title={title || "Pay Deposit"}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <Link to="/bankdetails" className='btn btn-lg btn-light me-3 mt-3' style={{ minWidth: '161px' }}>
                                        Previous
                                    </Link>
                                </div>
                            </Col>
                            <Col md={4}>
                                {/* <PriceSummery /> */}
                                <div className="">
                                    {/* Quote Reference Box */}
                                    <div className="mb-3 p-4 text-white rounded sidebar-box-green">
                                        <h5 className="mb-1 sidebar-label">Quote Reference</h5>
                                        <h3 className="mb-3 fw-bold">{refData?.referenceCode || ''}</h3>
                                        <hr className="my-3 sidebar-divider" />
                                        <p className="mb-1 sidebar-label">If you need help call us on</p>
                                        <h3 className="mb-3 fw-bold">0203 302 9263</h3>
                                        <hr className="my-3 sidebar-divider" />
                                        <h5 className="mb-0">Home Insurance</h5>
                                    </div>

                                    {/* Your Security Box */}
                                    <div className="mb-3 p-4 bg-white rounded shadow-sm">
                                        <h4 className="fw-bold mb-3 sidebar-heading-small">Your security:</h4>
                                        <p className="small mb-3">Your information is secured with a 256 bit SSL connection provided by our technology partner GoDaddy.</p>
                                        <img src={godaddyImage} alt="SSL Connection" className="img-fluid" />
                                    </div>

                                    {/* Contact Us Box */}
                                    <div className="mb-3 p-4 text-white rounded sidebar-box-dark">
                                        <h4 className="fw-bold mb-3 sidebar-heading-small">Contact us:</h4>
                                        <p className="mb-1 small">Call us on our phone number</p>
                                        <h4 className="mb-3 fw-bold">0203 302 9263</h4>

                                        <p className="mb-1 small">Email:</p>
                                        <p className="mb-3 fw-bold sidebar-label">sales@thamesbankinsurance.co.uk</p>

                                        <h4 className="fw-bold mb-2 sidebar-heading-small">Office Hours:</h4>
                                        <p className="mb-1 fw-bold">Mon to Thur</p>
                                        <p className="mb-2 small">9.00 am to 6.30 pm</p>
                                        <p className="mb-3 small">Fri 9.00 am to 5.30 pm</p>

                                        <p className="small lh-sm sidebar-tiny-text">
                                            Thamesbank Insurance Services is a trading name of Paragon Car Limited and are authorised and regulated by the Financial Conduct Authority, FCA no: 312028
                                        </p>
                                    </div>

                                    {/* Payment Options Box */}
                                    <div className="mb-3 p-4 bg-white rounded shadow-sm">
                                        <h4 className="fw-bold mb-3 sidebar-heading-small">Payment options:</h4>
                                        <p className="small mb-3">We accept all major credit and debit cards and offer payment by monthly instalments under the Direct Debit Guarantee</p>
                                        <img src="https://thamesbankassets.netlify.app/cardLogos.png" alt="Visa Mastercard Maestro Direct Debit" className="img-fluid" />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </div>
            <Footer />
        </div>
    );
}

export default PayDeposit;
